/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const customDriver = {
  type: 'custom',
  mount(container, ctx) {
    const customDef = /** @type {import('../../../contracts/forms.js').CustomFieldDef} */ (ctx.def);
    const innerHandle = customDef.render(container, {
      value: ctx.value,
      onChange: ctx.onChange,
      setErrors: ctx.setErrors,
    });
    return {
      setValue(v) { innerHandle.setValue(v); },
      getValue() { return innerHandle.getValue(); },
      setErrors() {
        // errors rendered by host wrapper
      },
      destroy() { innerHandle.destroy(); },
      setDisabled(disabled) {
        if (typeof innerHandle.setDisabled === 'function') innerHandle.setDisabled(disabled);
      },
      setVisible(visible) {
        if (typeof innerHandle.setVisible === 'function') innerHandle.setVisible(visible);
      },
      clearValue() {
        if (typeof innerHandle.clearValue === 'function') innerHandle.clearValue();
        else innerHandle.setValue(null);
      },
      getOptionsProvider() {
        if (typeof innerHandle.getOptionsProvider === 'function') return innerHandle.getOptionsProvider();
        return undefined;
      },
      setAriaInvalid(invalid) {
        if (typeof innerHandle.setAriaInvalid === 'function') innerHandle.setAriaInvalid(invalid);
      },
    };
  },
};
